import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { countries } from 'src/@order/commonData/commonUiData';

@Component({
  selector: 'app-forgot-password-methods',
  templateUrl: './forgot-password-methods.component.html',
  styleUrls: ['./forgot-password-methods.component.scss']
})
export class ForgotPasswordMethodsComponent implements OnInit {
  selectedCountryCode = '+233';
  phoneNumber: FormControl = new FormControl('');
  email: FormControl = new FormControl('');
  countries = countries;

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<ForgotPasswordMethodsComponent>,
  ) {

    if (_data.type == 'phone') {
      this.phoneNumber.setValidators([Validators.required, Validators.pattern(this.selectedCountryCode == '+233' ? '[0-9]{9,9}' : '[0-9]{10,10}')]);
    } else if (_data.type == 'email') {
      this.email.setValidators([Validators.required, Validators.email]);
    }


  }

  ngOnInit(): void {
  }

  onSubmit() {
    // console.log("selectedCountryCode", this.selectedCountryCode);
    // console.log("phoneNumber", this.phoneNumber);
    if (this._data.type == 'phone') {
      if (this.phoneNumber.invalid) {
        this.phoneNumber.markAllAsTouched();
      } else {
        this._matDialogRef.close({ code: this.selectedCountryCode, phoneNumber: this.phoneNumber.value })
      }
    }
    else if (this._data.type == 'email') {
      if (this.email.invalid) {
        this.email.markAllAsTouched();
      } else {
        this._matDialogRef.close({ email: this.email.value })
      }
    }

  }

  changeCountry() {
    // console.log("this.selectedCountryCode", this.selectedCountryCode);
    this.phoneNumber.setValidators([Validators.required, Validators.pattern(this.selectedCountryCode == '+233' ? '[0-9]{9,9}' : '[0-9]{10,10}')])
    this.phoneNumber.updateValueAndValidity();
  }

}
